<template lang="pug">
  .animated-number
    svg.hundreds(v-if="progress === 100" width="50" height="85" fill="none" xmlns="http://www.w3.org/2000/svg")
      use(xlink:href="#number-1")
    svg.tens(width="50" height="85" fill="none" xmlns="http://www.w3.org/2000/svg")
      use(:class="{'show': tens===0}" xlink:href="#number-0")
      use(:class="{'show': tens===1}" xlink:href="#number-1")
      use(:class="{'show': tens===2}" xlink:href="#number-2")
      use(:class="{'show': tens===3}" xlink:href="#number-3")
      use(:class="{'show': tens===4}" xlink:href="#number-4")
      use(:class="{'show': tens===5}" xlink:href="#number-5")
      use(:class="{'show': tens===6}" xlink:href="#number-6")
      use(:class="{'show': tens===7}" xlink:href="#number-7")
      use(:class="{'show': tens===8}" xlink:href="#number-8")
      use(:class="{'show': tens===9}" xlink:href="#number-9")
    svg.single(width="50" height="85" fill="none" xmlns="http://www.w3.org/2000/svg")
      use(:class="{'show': single===0}" xlink:href="#number-0")
      use(:class="{'show': single===1}" xlink:href="#number-1")
      use(:class="{'show': single===2}" xlink:href="#number-2")
      use(:class="{'show': single===3}" xlink:href="#number-3")
      use(:class="{'show': single===4}" xlink:href="#number-4")
      use(:class="{'show': single===5}" xlink:href="#number-5")
      use(:class="{'show': single===6}" xlink:href="#number-6")
      use(:class="{'show': single===7}" xlink:href="#number-7")
      use(:class="{'show': single===8}" xlink:href="#number-8")
      use(:class="{'show': single===9}" xlink:href="#number-9")

</template>

<script>
  import { mapState, mapMutations } from 'vuex'
export default {
  name: 'animated-number',
  props: {
    progress: {
      required: true,
      default: 0,
    },
  },
  components: {},
  data() {
    return {

    }
  },
  computed: {
    tens(){
      //console.log(Math.floor(this.progress/10))
      return Math.floor(this.progress/10)%10

    },
    single(){
      //console.log(this.progress%10)
      return this.progress%10
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    update() {},
  },
  watch: {},
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"


.animated-number
  +full()
  pointer-events: none
  display: flex
  flex-direction: row
  justify-content: center
  align-items: center
  .tens
    //width: 0.5rem
    use
      opacity: 0
      &.show
        opacity: 1

  .single
    //width: 0.5rem
    use
      opacity: 0
      &.show
        opacity: 1




</style>
